<template>
    <h1>PRICE LISTS MARGIN DIALOG</h1>
</template>

<script>
export default {
    name: "PriceListsMarginDialog.vue"
}
</script>